import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WidgetDefinition, WidgetRegistryService } from '@sdbn/common';
import { EquipmentAdminWidgetComponent } from './equipment-admin/equipment-admin-widget/equipment-admin-widget.component';
import { EquipmentAdminModule } from './equipment-admin/equipment-admin.module';



@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    EquipmentAdminModule
  ]
})
export class TmcCommonEquipmentModule {

  APP_CLIENT_WIDGET_DEFINITION = [
    { key: 'equipmentAdmin', name: 'Equipment Admin', description: '', icon: 'fa-light fa-vest', groupIdentifier: 'administration', widgetComponent: EquipmentAdminWidgetComponent, editorComponent: null }

  ];

  constructor(
    widgetRegistryService: WidgetRegistryService
  ) {

    console.log('*** initializing app client product ***')
    for (const definition of this.APP_CLIENT_WIDGET_DEFINITION) {
      if (definition != null) {
        widgetRegistryService.registerWidget(new WidgetDefinition(definition));
      }
    }

  }

}
